import React from 'react';
import ChecklistItem from './checklistItem.component';
import { useTypedTranslation } from '@app/hooks';
import { IStepCategory, IStep } from '@app/models';

interface IProps {
    category: IStepCategory;
}

const ChecklistCategory: React.SFC<IProps> = ({ category }) => {
    const { translation } = useTypedTranslation();
    const steps = category.steps.map((step: IStep, index) => <ChecklistItem step={step} key={index} />);

    return (
        <>
            <h3 className='header--h3 gettingstarted__header'>{translation(category.categoryName)}</h3>
            {steps}
        </>
    );


};

export default ChecklistCategory;
